import React from 'react';
import { useHasScrolled } from '@atlassiansox/bxp-content-framework';
import { BigNav } from './big';
import { SmallNav } from './small';
import { useIsLoggedIn } from '../../components';
import { Skip } from './UiHeaderNav.styles';
export default function UiHeaderNav({ model: model }) {
    var _a;
    const hasScrolled = useHasScrolled(40);
    const isLoggedIn = useIsLoggedIn();
    return (React.createElement(React.Fragment, null,
        React.createElement(Skip, null,
            React.createElement("a", { id: "skip-to-content", href: "#skip-target", className: "visually-hidden" }, (_a = model.content.skipToMainContent) !== null && _a !== void 0 ? _a : 'Skip to main content')),
        React.createElement(BigNav, { hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, model: model }),
        React.createElement(SmallNav, { hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, model: model })));
}
//# sourceMappingURL=UiHeaderNav.js.map